/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICRTouchConnection
 */
export interface ICRTouchConnection {
    /**
     * 
     * @type {number}
     * @memberof ICRTouchConnection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ICRTouchConnection
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof ICRTouchConnection
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICRTouchConnection
     */
    updatedAt: Date | null;
}

/**
 * Check if a given object implements the ICRTouchConnection interface.
 */
export function instanceOfICRTouchConnection(value: object): value is ICRTouchConnection {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ICRTouchConnectionFromJSON(json: any): ICRTouchConnection {
    return ICRTouchConnectionFromJSONTyped(json, false);
}

export function ICRTouchConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICRTouchConnection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

  export function ICRTouchConnectionToJSON(json: any): ICRTouchConnection {
      return ICRTouchConnectionToJSONTyped(json, false);
  }

  export function ICRTouchConnectionToJSONTyped(value?: ICRTouchConnection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': (value['updatedAt'] == null ? null : (value['updatedAt'] as any).toISOString()),
    };
}

